import { render, staticRenderFns } from "./PPropertyTile.vue?vue&type=template&id=2b0d1fc0"
import script from "./PPropertyTile.vue?vue&type=script&lang=js"
export * from "./PPropertyTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports